const data = [
  { id: 1, name: "Credor" },
  { id: 2, name: "Advogado" },
  { id: 3, name: "Credor (Advogado)" },
];

export default [...data];
